import { configureStore,combineReducers } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import cart from '../actions/cartSlice'
import user from '../actions/userSlice'
import location from '../actions/locationSlice'

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['cart','user','location'],
}

const rootReducer = combineReducers({
  cart: cart,
  user: user,
  location: location
})

const persistedReducer = persistReducer(persistConfig, rootReducer)
export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
})

export const persistor = persistStore(store)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch